module.exports = __webpack_public_path__ + "img/42.5d8e372a.png";